import React, { ReactNode } from "react";
import Header from "layouts/Header";
import clsx from "clsx";
import Toast from "components/Toast";
import { globalStore } from "store/GlobalStore";
import { observer } from "mobx-react-lite";
import { IS_CONCULAR_ONE } from "utils";
import SidebarMenu from "features/SidebarMenu";
interface IProps {
  children?: ReactNode;
  className?: string;
  headerTitle?: React.ReactNode;
  noHeader?: boolean;
}

const MainLayout = ({ children, className, headerTitle, noHeader }: IProps) => {
  const handleSidebar = () =>
    globalStore.setSidebarOpened(!globalStore.sidebarOpened);
  const { toastList } = globalStore;

  return (
    <>
      <SidebarMenu
        open={globalStore.sidebarOpened}
        toggleSidebar={handleSidebar}
      />
      <div
        className={clsx("transition-all", {
          "md:ml-[350px]": globalStore.sidebarOpened,
        })}
      >
        {noHeader ? null : (
          <Header headerTitle={headerTitle} toggleSidebar={handleSidebar} />
        )}
        <div
          className={clsx(
            "min-h-[calc(100vh-64px)] bg-gray-50 flex flex-col",
            className,
            {
              "min-h-[100vh]": IS_CONCULAR_ONE,
            }
          )}
        >
          {children}
        </div>
        {toastList && <Toast toastList={toastList} />}
      </div>
    </>
  );
};

export default observer(MainLayout);
